module.exports = __webpack_public_path__ + "img/pexels-olenka-sergienko-3686769.2af33c9f.jpg";